"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
require("./tricon2-sk");
